var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32.3368,
    height: 32,
    rx: 4,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5055 14.1667C24.5055 20.5834 16.1686 26.0834 16.1686 26.0834C16.1686 26.0834 7.83179 20.5834 7.83179 14.1667C7.83179 11.9787 8.71013 9.88023 10.2736 8.33306C11.8371 6.78588 13.9576 5.91669 16.1686 5.91669C18.3797 5.91669 20.5002 6.78588 22.0637 8.33306C23.6271 9.88023 24.5055 11.9787 24.5055 14.1667Z",
    stroke: "#718096",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1686 16.9167C17.7034 16.9167 18.9475 15.6855 18.9475 14.1667C18.9475 12.6479 17.7034 11.4167 16.1686 11.4167C14.6338 11.4167 13.3896 12.6479 13.3896 14.1667C13.3896 15.6855 14.6338 16.9167 16.1686 16.9167Z",
    stroke: "#718096",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.77e2a04b8224bd7f317f1f6b391a5ee4.svg";
export { ForwardRef as ReactComponent };